import { AlertBanner } from '@latitude/alert-banner';

import type { FallbackProps } from './caughtError';

/**
 * Default fallback for {@link RootErrorBoundary}. Offers a full page reload
 * rather than `resetErrorBoundary`: at the app root a render error is usually
 * deterministic, so re-rendering the same subtree would just throw again. A
 * reload is the reliable recovery for a client-only SPA.
 */
export function RootErrorFallback({ error }: FallbackProps) {
  return (
    <AlertBanner
      variant="error"
      title="Something went wrong"
      description="An unexpected error occurred. Reload the page to try again."
      detailsText={error.message}
      buttonLabel="Reload page"
      onActionClick={() => window.location.reload()}
      data-testid="root-error-boundary-fallback"
    />
  );
}
